const isCacheFresh = (cachedResponse) => {
    const cacheMaxAge = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
    const cachedTime = cachedResponse.headers.get('date');
    if (!cachedTime) return false;

    // Check if cache is still fresh
    return new Date().getTime() - cachedTime <= cacheMaxAge;
};

export default isCacheFresh;
